export const REQUIREMENT_STATUS_IDS = [
  'not_started',
  'in_progress',
  'in_contact',
  'completed',
  'rejected',
  'cancelled',
  'archived',
];

export const REQUIREMENT_STATUS_COLUMNS = [
  {
    id: 'not_started',
    label: 'Not Started',
    shortLabel: 'New',
    color: '#94A3B8',
    bg: 'rgba(148,163,184,0.12)',
    border: 'rgba(148,163,184,0.35)',
  },
  {
    id: 'in_progress',
    label: 'In Progress',
    shortLabel: 'Doing',
    color: '#38BDF8',
    bg: 'rgba(56,189,248,0.12)',
    border: 'rgba(56,189,248,0.35)',
  },
  {
    id: 'in_contact',
    label: 'In Contact',
    shortLabel: 'Contact',
    color: '#818CF8',
    bg: 'rgba(129,140,248,0.12)',
    border: 'rgba(129,140,248,0.35)',
  },
  {
    id: 'completed',
    label: 'Completed',
    shortLabel: 'Done',
    color: '#10B981',
    bg: 'rgba(16,185,129,0.12)',
    border: 'rgba(16,185,129,0.35)',
  },
  {
    id: 'rejected',
    label: 'Rejected',
    shortLabel: 'Rejected',
    color: '#F87171',
    bg: 'rgba(248,113,113,0.12)',
    border: 'rgba(248,113,113,0.35)',
  },
  {
    id: 'cancelled',
    label: 'Cancelled',
    shortLabel: 'Cancelled',
    color: '#FB923C',
    bg: 'rgba(251,146,60,0.12)',
    border: 'rgba(251,146,60,0.35)',
  },
  {
    id: 'archived',
    label: 'Archived',
    shortLabel: 'Archived',
    color: '#94A3B8',
    bg: 'rgba(148,163,184,0.12)',
    border: 'rgba(148,163,184,0.35)',
  },
];

export const REQUIREMENT_STATUS_FILTER_OPTIONS = REQUIREMENT_STATUS_COLUMNS.map((c) => ({
  value: c.id,
  label: c.label,
}));

export function resolveRequirementStatus(requirement) {
  if (requirement?.archived_at) return 'archived';
  const raw = String(requirement?.status ?? 'not_started').toLowerCase();
  return REQUIREMENT_STATUS_IDS.includes(raw) ? raw : 'not_started';
}

export function getRequirementStatusMeta(statusId) {
  const resolved = typeof statusId === 'object'
    ? resolveRequirementStatus(statusId)
    : statusId;
  return REQUIREMENT_STATUS_COLUMNS.find((c) => c.id === resolved) ?? REQUIREMENT_STATUS_COLUMNS[0];
}

export function getRequirementStatusSortRank(requirementOrStatus) {
  const resolved = typeof requirementOrStatus === 'object'
    ? resolveRequirementStatus(requirementOrStatus)
    : resolveRequirementStatus({ status: requirementOrStatus });
  const idx = REQUIREMENT_STATUS_IDS.indexOf(resolved);
  return idx === -1 ? REQUIREMENT_STATUS_IDS.length : idx;
}

/** Emergency first; then workflow status order; then most recently updated. */
export function compareRequirementListItems(a, b) {
  const er = Number(Boolean(b.is_emergency)) - Number(Boolean(a.is_emergency));
  if (er !== 0) return er;

  const sr = getRequirementStatusSortRank(a) - getRequirementStatusSortRank(b);
  if (sr !== 0) return sr;

  return compareRequirementKanbanItems(a, b);
}

/** Emergency requests first, then most recently updated. */
export function compareRequirementKanbanItems(a, b) {
  const er = Number(Boolean(b.is_emergency)) - Number(Boolean(a.is_emergency));
  if (er !== 0) return er;
  const ta = new Date(a.updated_at ?? a.created_at ?? 0).getTime();
  const tb = new Date(b.updated_at ?? b.created_at ?? 0).getTime();
  return tb - ta;
}
